module.exports = __webpack_public_path__ + "assets/img/Aussie-Broadband-eBook.12843020.jpg";